import { Spacer } from '@vinted/web-ui'

import AppButton from './AppButton'

const AppStoreButtons = () => {
  return (
    <div>
      <AppButton platform={AppButton.Platform.Ios} />
      <Spacer orientation="vertical" size="large" />
      <AppButton platform={AppButton.Platform.Android} />
      <Spacer orientation="vertical" size="large" />
    </div>
  )
}

export default AppStoreButtons
